import { Fragment } from "react";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocTableSimple from "../../../utils/MeditocTableSimple";
import RowTotales from "./RowTotales";
import { getResumenFoliosColumns } from "../../../../models/EmpresaModel";
import { useEmpresa } from "../../../../context/EmpresaContext";

export default function ResumenAgregarFolios() {
    const {
        listaProductosSeleccionados,
        subtotal,
        montoIva,
        modalOpenResumenAgregarFolios,
        handleOpenResumenAgregarFolios,
        handleCloseAgregarFolios,
        handleSubmitGenerarFolios,
    } = useEmpresa();

    return (
        <MeditocModal
            title="Confirmación generar folios"
            setopen={handleOpenResumenAgregarFolios}
            cancelFunc={handleCloseAgregarFolios}
            open={modalOpenResumenAgregarFolios}
            okfunc={handleSubmitGenerarFolios}
            okmessage="Confirmar compra"
            cancelMessage="Regresar"
            size="medium"
        >
            <MeditocTableSimple
                columns={getResumenFoliosColumns()}
                data={listaProductosSeleccionados.map((producto) => ({
                    ...producto,
                    sSubtotal:
                        "$" +
                        (producto.iCantidad * producto.fCosto).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                        }),
                }))}
                addRows={
                    <Fragment>
                        <RowTotales
                            colSpan={4}
                            label="Subtotal"
                            value={"$" + subtotal.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                        />
                        <RowTotales
                            colSpan={4}
                            label="IVA"
                            value={"$" + montoIva.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                        />
                        <RowTotales
                            colSpan={4}
                            label="Total"
                            value={"$" + (subtotal + montoIva).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                        />
                    </Fragment>
                }
            />
        </MeditocModal>
    );
}
